
addEventListener("load", (event) => {
  setTimeout(function(){
    let fechaInicial = new Date("Febrero 14, 2024 17:00:00 GMT-0500").getTime();
    let fechaAhora = new Date().getTime();
    $(".visibility-cronometro-or-reviews").each(function(i){
      if($(this).val() == "cronometro" && fechaAhora > fechaInicial){
        $(".container-cronometro").eq(i).attr("style", "display: flex");
        //$(".reviews-catalog").eq(i).attr("style", "display: none");
      }else{
        //$(".container-cronometro").eq(i).attr("style", "display: none");
        $(".reviews-catalog").eq(i).attr("style", "display: flex");
      }
    })

    if(fechaAhora > fechaInicial){
      $(".top-left.top-left-img-superoferta").attr("style", "display: block !important");
    }
  },1500)
})



var countDownDateGrid = new Date("Febrero 16, 2024 17:00:00 GMT-0500").getTime();

var x = setInterval(function() {
  var now = new Date().getTime();
  
  var distanceGrid = countDownDateGrid - now;
  var daysGrid = Math.floor(distanceGrid / (1000 * 60 * 60 * 24));
  var hoursGrid = Math.floor((distanceGrid % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesGrid = Math.floor((distanceGrid % (1000 * 60 * 60)) / (1000 * 60));
  var secondsGrid = Math.floor((distanceGrid % (1000 * 60)) / 1000);
    
    if(daysGrid.toString().length > 1){
      if(daysGrid.toString().length > 2){
        $(".countdownDay").html("<div><span>"+daysGrid.toString()[0]+"</span><span>"+daysGrid.toString()[1]+"</span><span>"+daysGrid.toString()[2]+"</span</div>><b>:</b>");
      }else{
        $(".countdownDay").html("<div><span>"+daysGrid.toString()[0]+"</span><span>"+daysGrid.toString()[1]+"</span></div><b>:</b>");
      }
      
    }else{
      $(".countdownDay").html("<div><span>0</span><span>"+daysGrid+"</span></div><b>:</b>");
    }

    if(hoursGrid.toString().length > 1){
      $(".countdownHour").html("<div><span>"+hoursGrid.toString()[0]+"</span><span>"+hoursGrid.toString()[1]+"</span></div><b>:</b>");
    }else{
      $(".countdownHour").html("<div><span>0</span><span>"+hoursGrid+"</span></div><b>:</b>");
    }

    if(minutesGrid.toString().length > 1){
      $(".countdownMinute").html("<div><span>"+minutesGrid.toString()[0]+"</span><span>"+minutesGrid.toString()[1]+"</span></div><b>:</b>");
    }else{
      $(".countdownMinute").html("<div><span>0</span><span>"+minutesGrid.toString()[0]+"</span></div><b>:</b>");
    }

    if(secondsGrid.toString().length > 1){
      $(".countdownSecond").html("<div><span>"+secondsGrid.toString()[0]+"</span><span>"+secondsGrid.toString()[1]+"</span></div>");
    }else{
      $(".countdownSecond").html("<div><span>0</span><span>"+secondsGrid+"</span></div>");
    }
  
  // If the count down is over, write some text 
  if (distanceGrid < 0) {
    clearInterval(x);
    $(".containerCronometro").attr("style", "visibility: hidden");
    $(".top-left.top-left-img-24horas").attr("style", "display: none !important");
  }
}, 1000);